export default {
  apiKey: "AIzaSyDAJC0eAv5cvhRm6Z47I43mme_zfNDl4UY",
  authDomain: "mygitapp-aedfe.firebaseapp.com",
  projectId: "mygitapp-aedfe",
  storageBucket: "mygitapp-aedfe.appspot.com",
  messagingSenderId: "535175230913",
  appId: "1:535175230913:web:5e18c8aad8c65e7ee92b40",
  measurementId: "G-VGZVZHGDYV",
};
